import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules';

export default function AreaOfInterest() {
    return (
        <>
            <section className='section bg-white'>
                <div className="container">
                    <h3 className='main-title text-center'>Area of Supply</h3>
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={20}
                        loop={true}

                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        pagination={{
                            clickable: true,
                        }}
                        breakpoints={{
                            640: {
                                slidesPerView: 1,
                                spaceBetween: 20,
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            1024: {
                                slidesPerView: 3,
                                spaceBetween: 20,
                            },
                            1500: {
                                slidesPerView: 4,
                                spaceBetween: 20,
                            },
                        }}
                        modules={[Pagination, Autoplay]}
                        effect={"fade"}
                        className="area-supply pb-5"
                    >
                        <SwiperSlide>
                            <div className='area-supply-div'>
                                <div className='overlay'></div>
                                <img src="assets/images/app1-automobile.jpg" />
                                <h4>Automobile Ancillery</h4>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className='area-supply-div'>
                                <div className='overlay'></div>
                                <img src="assets/images/app2-textile.jpg" />
                                <h4>Textile Machinery</h4>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className='area-supply-div'>
                                <div className='overlay'></div>
                                <img src="assets/images/app3-defence.jpg" />
                                <h4>Defence</h4>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className='area-supply-div'>
                                <div className='overlay'></div>
                                <img src="assets/images/app4-pharma.jpg" />
                                <h4>Pharma Machinery</h4>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className='area-supply-div'>
                                <div className='overlay'></div>
                                <img src="assets/images/app5-food-processing.jpg" />
                                <h4>Food Processing Ind.</h4>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className='area-supply-div'>
                                <div className='overlay'></div>
                                <img src="assets/images/app7-printing.jpg" />
                                <h4>Printing & Paper Ind</h4>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className='area-supply-div'>
                                <div className='overlay'></div>
                                <img src="assets/images/app8-dia.jpg" />
                                <h4>Dia & Mold</h4>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className='area-supply-div'>
                                <div className='overlay'></div>
                                <img src="assets/images/app9-bearing.jpg" />
                                <h4>Bearings Industries</h4>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </section>
        </>
    )
}